import { Form } from "react-bootstrap";
import { GridFormFlexItemWrapper } from "@bagel-web/components";
import { CommonKVDelTreeMessage } from "../../types";
import {
  EditMessageComponent,
  EditMessageComponentProps,
  EventBody,
  MessageComponent,
  MessageComponentProps,
} from "./Message";

const KVDelTreeMessage: MessageComponent<CommonKVDelTreeMessage> = ({
  message,
}: MessageComponentProps<CommonKVDelTreeMessage>) => {
  return (
    <>
      <h6>
        <code>{message.key}</code>
      </h6>
    </>
  );
};

export const EditKVDelTreeMessage: EditMessageComponent<
  CommonKVDelTreeMessage
> = ({
  message,
  onGameEventMessageChange,
}: EditMessageComponentProps<CommonKVDelTreeMessage>) => {
  return (
    <GridFormFlexItemWrapper>
      <Form.Label className="mb-3">Key</Form.Label>
      <EventBody style={{ flexGrow: 1 }}>
        <Form.Control
          required
          value={message.key}
          onChange={(e) =>
            onGameEventMessageChange({
              ...message,
              key: e.target.value,
            })
          }
        />
      </EventBody>
    </GridFormFlexItemWrapper>
  );
};

export default KVDelTreeMessage;
